<div class="simple-page-container">

  <div class="container">


    <app-section-heading [label]="'MENU.MENU_4' | translate"></app-section-heading>
    <!--    <div class="page-heading">-->
    <!--      <h1 class="page-title">{{'MENU.MENU_4' | translate}}</h1>-->
    <!--      <hr class="divider">-->
    <!--    </div>-->


    <div class="row">
      <div class="col-12 col-sm-6 col-md-4 mb-4" *ngFor="let item of subcontractors">
        <mat-card class="d-flex flex-column align-items-center justify-content-center" (click)="openURL(item.link)">
          <img *ngIf="item.imageUrl" class="mb-4" [src]="item.imageUrl"/>
          <div class="text-content text-center">
            <div class="name font-weight-bold">{{item.name}}</div>
            <div *ngIf="item.description">{{item.description}}</div>
            <div class="link">
              {{item.link}}
            </div>
          </div>
        </mat-card>
      </div>
    </div>

    <app-section-heading class="d-block mt-4" [label]="'COMMON.SUPPLIERS' | translate"></app-section-heading>
    <div class="row">
      <div class="col-12 col-sm-6 col-md-4 mb-4" *ngFor="let item of suppliers">
        <mat-card class="d-flex flex-column align-items-center justify-content-center" (click)="openURL(item.link)">
          <img *ngIf="item.imageUrl" class="mr-4" [src]="item.imageUrl"/>
          <div class="text-content text-center">
            <div class="name">{{item.name}}</div>
            <div *ngIf="item.description">{{item.description}}</div>
            <div class="link">
              {{item.link}}
            </div>
          </div>
        </mat-card>
      </div>
    </div>

    <!--    <div class="partner-list-container">-->

    <!--      <div class="row">-->

    <!--        <div class="col-12">-->
    <!--          <mat-card class="section-head">-->
    <!--            <mat-card-content>-->
    <!--              <div class="title overflow-ellipsis">-->
    <!--                Alvállalkozóink-->
    <!--              </div>-->
    <!--            </mat-card-content>-->
    <!--          </mat-card>-->
    <!--        </div>-->

    <!--      </div>-->

    <!--      <div class="row">-->
    <!--        <div class="col-12 col-md-4 col-lg-3" *ngFor="let item of subcontractors">-->
    <!--          <mat-card>-->
    <!--            <mat-card-content [class.has-link]="!!item.link" (click)="openURL(item.url)">-->
    <!--              <div class="title overflow-ellipsis">-->
    <!--                {{item.name}}-->
    <!--              </div>-->
    <!--            </mat-card-content>-->
    <!--          </mat-card>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="row">-->

    <!--        <div class="col-12">-->
    <!--          <mat-card class="section-head">-->
    <!--            <mat-card-content>-->
    <!--              <div class="title overflow-ellipsis">-->
    <!--                Beszállítóink-->
    <!--              </div>-->
    <!--            </mat-card-content>-->
    <!--          </mat-card>-->
    <!--        </div>-->

    <!--      </div>-->

    <!--      <div class="row">-->
    <!--        <div class="col-12 col-md-4 col-lg-3" *ngFor="let item of suppliers">-->
    <!--          <mat-card [class.has-link]="!!item.link" (click)="openURL(item.url)">-->
    <!--            <mat-card-content>-->
    <!--              <div class="title overflow-ellipsis">-->
    <!--                {{item.name}}-->
    <!--              </div>-->
    <!--            </mat-card-content>-->
    <!--          </mat-card>-->
    <!--        </div>-->
    <!--      </div>-->


    <!--    </div>-->

    <!--<div class="editor-container">-->
    <!--<app-html-editor-wrapper *ngIf="content" (contentSaved)="onContentSaved($event)"-->
    <!--[value]="content"></app-html-editor-wrapper>-->
    <!--</div>-->
  </div>
</div>
